import { render, staticRenderFns } from "./ProfileUserCard.vue?vue&type=template&id=c52a07c6&scoped=true"
import script from "./ProfileUserCard.vue?vue&type=script&lang=js"
export * from "./ProfileUserCard.vue?vue&type=script&lang=js"
import style0 from "./ProfileUserCard.vue?vue&type=style&index=0&id=c52a07c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52a07c6",
  null
  
)

export default component.exports